import {
  LOAD_OPEN_INCIDENT_SUCCESS,
  LOAD_OPEN_INCIDENT_FAILED,
  LOAD_CLOSE_INCIDENT_SUCCESS,
  LOAD_CLOSE_INCIDENT_FAILED,
  ADD_RESOLUTION_PROPOSAL_ACTION_SUCCESS,
  ADD_RESOLUTION_PROPOSAL_ACTION_FAILED
} from "./incidentActionTypes";

export default (state = [], action) => {
  switch (action.type) {
    case LOAD_OPEN_INCIDENT_FAILED:
      return [{ key: LOAD_OPEN_INCIDENT_FAILED }];
    case LOAD_CLOSE_INCIDENT_FAILED:
      return [{ key: LOAD_CLOSE_INCIDENT_FAILED }];
    case ADD_RESOLUTION_PROPOSAL_ACTION_FAILED:
      return [{ key: ADD_RESOLUTION_PROPOSAL_ACTION_FAILED }];
    case ADD_RESOLUTION_PROPOSAL_ACTION_SUCCESS:
    case LOAD_OPEN_INCIDENT_SUCCESS:
    case LOAD_CLOSE_INCIDENT_SUCCESS:
      return [];
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/incidents/errorsReducer.js